import React, { useContext, useState } from "react";
import "./Account_banner_holder.css";
import { Link } from "react-router-dom";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LogoutModal from "../../../components/Common-Component/Commonmodal/LogoutModal/LogoutModal";
import { Context } from "../../../utils/context";

function Account_banner_holder({ user, pointSetup, WalletHistory }) {
  const [logoutshow, setLogoutshow] = useState(false);

  const { signin, setSignin } = useContext(Context);
  return (
    <>
      <section className="Account_banner_holder">
        <div className="banner_holder">
          <div className="banner_account_detals_card_holder">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="banner_heading_holder">
                  <div className="text_holder">
                    <h4>HELLO</h4>
                    <h1>
                      {user?.first_name} {user?.last_name}
                    </h1>
                  </div>

                  <div className="text_holder">
                    <h3
                      className=" sign_out_text"
                      onClick={() => setLogoutshow(true)}
                    >
                      {" "}
                      <FontAwesomeIcon
                        className="me-3"
                        icon={faArrowRightFromBracket}
                      />
                      SIGN OUT
                    </h3>
                  </div>
                </div>
                <div className="account_details_text_holder">
                  <div className="banner_heading_holder">
                    <div className="text_holder">
                      <h5>LOYALTY COINS</h5>
                      <p>
                        Earn loyalty points for every rupee you spend with us.
                      </p>
                    </div>

                    <div className="text_holder">
                      <Link to={"/luxury/my-rewards"}>
                        <p className="text_decoration_holder">View Rewards</p>
                      </Link>
                    </div>
                  </div>

                  <div className="account_img_holder">
                    <div className="img_holder">
                      <img
                        src="/COINZKART_favicon.png"
                        alt="user"
                        className="user_img"
                      />
                    </div>

                    <p>Rewards # {user?.contact_no}</p>
                  </div>

                  <div className="count_holder">
                    <div className="row">
                      <div className="col-md-6 col-sm-6  mb-3">
                        <div className="text_holder">
                          <div className="row">
                            <div className="col-md-6  col-6">
                              <h2>Coin</h2>
                            </div>

                            <div className="col-md-6  col-6">
                              <h2 className="text-end">{user?.point}</h2>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 col-sm-6  mb-3">
                        <div className="text_holder">
                          <div className="row">
                            <div className="col-md-6 col-6">
                              <h2>Redeemable Value</h2>
                            </div>

                            <div className="col-md-6  col-6">
                              <h2 className="text-end">
                                ₹{" "}
                                {Number(user?.point) *
                                  Number(pointSetup?.discount_amount)}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <LogoutModal
          show={logoutshow}
          onHide={() => setLogoutshow(false)}
          text="Are you sure you want to log out?"
          setSignin={setSignin}
        />
      </section>
    </>
  );
}

export default Account_banner_holder;
